import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { useEncryptedEndpointsRadioSwitch } from 'app/registries/linked-service/linked-service-shared-fields';
import { format } from 'app/shared/utils/string.util';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { driverVersionPreviewVersionOptions, driverVersions } from '../consts/tabular-consts';
import { GlobalVariables } from 'app/services/globals';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

const connectionForm: ControlMetadata[] = [
    {
        type: 'textbox',
        bind: 'clientId',
        label: stringResources.ModelName_ClientId,
        required: true,
        validators: [
            { type: 'required', errorMessage: '' }
        ],
        isLabelVertical: true
    },
    {
        type: 'dynamic-akv-switcher',
        bind: 'clientSecret',
        label: stringResources.ModelName_ClientSecret,
        child: {
            type: 'password',
            label: stringResources.ModelName_ClientSecret,
            isLabelVertical: true,
            required: true
        },
        validators: [
            { type: 'required', errorMessage: '' }
        ],
        description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
            format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Hubspot_DisplayText),
            stringResources.ModelName_ClientSecret)
    },
    {
        type: 'dynamic-akv-switcher',
        bind: 'accessToken',
        label: stringResources.ModelName_AccessToken,
        child: {
            type: 'password',
            label: stringResources.ModelName_AccessToken,
            isLabelVertical: true,
            required: true
        },
        validators: [
            { type: 'required', errorMessage: '' }
        ],
        description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
            format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Hubspot_DisplayText),
            stringResources.ModelName_AccessToken)
    },
    {
        type: 'dynamic-akv-switcher',
        bind: 'refreshToken',
        label: stringResources.ModelName_RefreshToken,
        child: {
            type: 'password',
            label: stringResources.ModelName_RefreshToken,
            isLabelVertical: true,
            required: true
        },
        validators: [
            { type: 'required', errorMessage: '' }
        ],
        description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
            format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Hubspot_DisplayText),
            stringResources.ModelName_RefreshToken)
    }
];
export const hubspotMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.hubspot.linkedServiceType,
    displayName: stringResources.Hubspot_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-hubspot'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    category: ['ServicesApps'],
    isDeprecated: GlobalVariables.showLegacy ? undefined : '{ version !== "v2" }',
    copySinkTypes: [],
    showWarningMessage: '{ version !== "v2" }',
    warningMessage:  format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt5,
            stringResources.VersionLabel.toLocaleLowerCase()),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-hubspot',
    copySourceTypes: [adfModelTypeMap.hubspot.copySourceType],
    SHIRVersion: {
        v2: '5.57.0.0'
    },
    controls: [        
        {
            type: 'radio-switch',
            isLabelVertical: true,
            label: stringResources.VersionLabel,
            required: true,
            bind: 'version',
            hide: GlobalVariables.showLegacy ? false : '{version === "v2" }',
            options: driverVersionPreviewVersionOptions,
            defaultValue: driverVersions.v2,
            cases: [
                        {
                            caseValue: driverVersions.v1,
                            children: [
                                {
                                    type: 'hint',
                                    hintMode: 'warning',
                                    description: format(
                                        stringResources.Connector_Legacy_IsNotSupportedWarning_alt6,
                                        stringResources.VersionLabel.toLocaleLowerCase()),
                                    link: 'https://learn.microsoft.com/azure/data-factory/connector-hubspot'
                                },
                                ...connectionForm,
                                useEncryptedEndpointsRadioSwitch
                            ]
                        },
                        {
                            caseValue: driverVersions.v2,
                            children: [...connectionForm]
                        }
                    ]
        },
        ...(connectionForm
            .map((control) => ({
                ...control,
                hide: !GlobalVariables.showLegacy ? '{version !== "v2" }' : true
            }))
        )
    ]
};
